import { render } from "./card-list-assessmen.vue?vue&type=template&id=178b863e&scoped=true"
import script from "./card-list-assessmen.vue?vue&type=script&lang=js"
export * from "./card-list-assessmen.vue?vue&type=script&lang=js"

import "./card-list-assessmen.vue?vue&type=style&index=0&id=178b863e&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178b863e"]])

export default __exports__